import { api } from "../Configurations/axios";
import { LoansFinancingModel } from "../Models/LoansFinancingModel";

const GetLoansFinancing = async (id: string) => {
    try {

        const result = await api.get(`/LoansfinancingFinep/GetByregistrationDocumentsId/${id}`);
        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PostLoansFinancing = async (model : LoansFinancingModel) => {
    try {

        const result = await api.post(`/LoansfinancingFinep/Post`, model);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

interface PutValidateLoansFinancingModel {
    registerId: string;
    isValid: boolean;
}

const PutValidateLoansinancingAndBilling = async (model : PutValidateLoansFinancingModel) => {
    try {

        const resultLoans = await api.put(`/LoansfinancingFinep/PutValidate`, model);
        const responseLoans = await resultLoans.data;


        const resultBilling = await api.put(`/BillingProductsFinep/PutValidate`, model);
        const responseBilling = await resultLoans.data;

        return true;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


export {
    GetLoansFinancing,
    PostLoansFinancing,
    PutValidateLoansinancingAndBilling
}